import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function RegisterRedirect() {
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		// Preserve query parameters when redirecting
		navigate(`/auth/register${location.search}`, { replace: true });
	}, [navigate, location.search]);

	return null;
}
